import { gradientPresets, imagePresets } from "@/lib/constants";
import type { BeautifierSettings } from "@/lib/types";

export function getSelectedPreset(settings: BeautifierSettings) {
  return (
    imagePresets.find((preset) => preset.id === settings.imagePresetId) ??
    imagePresets[0]
  );
}

export function getBackgroundStyle(settings: BeautifierSettings) {
  const base = {
    backgroundColor: settings.backgroundColor,
    backgroundImage: "",
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  if (settings.backgroundType === "gradient") {
    const gradient =
      gradientPresets.find((preset) => preset.id === settings.gradientPreset)
        ?.value ?? gradientPresets[0].value;

    return { ...base, backgroundImage: gradient };
  }

  if (settings.backgroundType === "pattern") {
    const patterns = {
      dots: "radial-gradient(circle, rgba(23,32,42,0.16) 1.5px, transparent 1.7px)",
      grid: "linear-gradient(rgba(23,32,42,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(23,32,42,0.1) 1px, transparent 1px)",
      lines:
        "repeating-linear-gradient(135deg, rgba(23,32,42,0.12) 0 2px, transparent 2px 18px)",
    };

    return {
      ...base,
      backgroundImage: patterns[settings.patternType],
      backgroundSize: settings.patternType === "dots" ? "28px 28px" : "36px 36px",
    };
  }

  if (settings.backgroundType === "image" && settings.customBackgroundImage) {
    return {
      ...base,
      backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.12), rgba(15, 23, 42, 0.12)), url(${settings.customBackgroundImage})`,
    };
  }

  return base;
}
